import React, { useContext } from 'react';
import classNames from 'classnames';
import { JobSearchContext } from '../../context';

const SmartFilters = () => {
  const { setKeyword, setKeywordUserInput, smartFilters, } = useContext(JobSearchContext);

  if (!smartFilters.length) return null;

  // Sets input "keywords" and URL `filter[keywords][]` values, the latest triggers the search
  const triggerKeywordSearch = (value: string) => {
    setKeyword(value);
    setKeywordUserInput(value);
  };

  return (
    <div className='mt-4' data-testid='smart-filters'>
      {smartFilters.map((filter, index) => {
        return (
          <button
            key={filter.value}
            role='button'
            onClick={() => triggerKeywordSearch(filter.value)}
            className={classNames('btn btn-link link-blue-orange margin-top-medium', {
              'margin-right-large': index !== 2,
            })}
          >
            <h3 className='fw-bold fs-5'>{filter.text}</h3>
          </button>
        );
      })}
    </div>
  );
};

export default SmartFilters;
